import { Button, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import { ADJUSTMENT_TYPES } from "./types";
import type { StockAdjustment } from "../../api-models";


export default function AdjustmentsListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "Adjustments.Write");

  return (
    <ListPage<StockAdjustment>
      title="Stock Adjustments"
      endpoint="/adjustments"
      searchPlaceholder="Search doc no or reason..."
      linkTo={(r) => `/adjustments/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/adjustments/new")} data-tour="adjustments-new">
            New adjustment
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Type", dataIndex: "type", sorter: true, render: (v: string) => <Tag>{ADJUSTMENT_TYPES.find((t) => t.value === v)?.label ?? v}</Tag> },
        { title: "Location", render: (_, r) => r.location?.name },
        { title: "Reason", dataIndex: "reason", ellipsis: true },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div>
            {r.type} · {r.location?.name}
          </div>
          <DocumentStatusTag status={r.status} />
        </div>
      )}
    />
  );
}
